import React from 'react';
import { CONTACT_URL } from '../config/links';

const Footer = () => {
  return (
    <footer className="bg-esf-black border-t border-white/[0.06]">
      <div className="gradient-border-top" />
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
        <div className="xl:grid xl:grid-cols-3 xl:gap-8">
          <div className="space-y-8 xl:col-span-1">
            <div className="flex justify-start">
              <a href="/" className="flex items-center font-logo text-2xl text-esf-white hover:text-esf-gray-100">
                <img src="/esf-icon-white.png" alt="Elite Sport Finance Logo" className="h-8 w-8 mr-2" />
                Elite Sport Finance
              </a>
            </div>
            <p className="text-body text-esf-gray-500 max-w-xs">
              Turning fan passion into club revenue.
            </p>
          </div>
          <div className="mt-12 grid grid-cols-2 gap-8 xl:mt-0 xl:col-span-2">
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 className="text-eyebrow uppercase text-esf-gray-500">Solutions</h3>
                <ul className="mt-4 space-y-4">
                  <li><a href="#product" className="text-body text-esf-gray-300 hover:text-esf-white transition-colors">White-Label Cards</a></li>
                  <li><a href="#product" className="text-body text-esf-gray-300 hover:text-esf-white transition-colors">Loyalty Programs</a></li>
                  <li><a href="#revenue" className="text-body text-esf-gray-300 hover:text-esf-white transition-colors">Affiliate Revenue</a></li>
                </ul>
              </div>
              <div className="mt-12 md:mt-0">
                <h3 className="text-eyebrow uppercase text-esf-gray-500">Support</h3>
                <ul className="mt-4 space-y-4">
                  <li><a href={CONTACT_URL} className="text-body text-esf-gray-300 hover:text-esf-white transition-colors">Contact us</a></li>
                </ul>
              </div>
            </div>
            <div className="md:grid md:grid-cols-2 md:gap-8">
              <div>
                <h3 className="text-eyebrow uppercase text-esf-gray-500">Company</h3>
                <ul className="mt-4 space-y-4">
                  <li><a href={CONTACT_URL} className="text-body text-esf-gray-300 hover:text-esf-white transition-colors">Careers</a></li>
                </ul>
              </div>
              <div className="mt-12 md:mt-0">
                <h3 className="text-eyebrow uppercase text-esf-gray-500">Legal</h3>
                <ul className="mt-4 space-y-4">
                  <li><a href="/privacy-policy" className="text-body text-esf-gray-300 hover:text-esf-white transition-colors">Privacy</a></li>
                  <li><a href="/terms" className="text-body text-esf-gray-300 hover:text-esf-white transition-colors">Terms</a></li>
                  <li><a href="/cookie-policy" className="text-body text-esf-gray-300 hover:text-esf-white transition-colors">Cookie Policy</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-12 border-t border-white/[0.06] pt-8">
          <p className="text-sm text-esf-gray-500 text-center">
            &copy; {new Date().getFullYear()} Elite Sport Finance AB. All rights reserved.
          </p>
          <p className="text-xs text-esf-gray-500 text-center mt-3">
            Elite Sport Finance AB is a technology provider. All banking services are provided by our banking partners.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
